<template>
	<div class="table_div">
		<el-form :inline="true" class="select_form">
			<el-form-item>
				<el-icon :size="20" @click='getBack()'>
					<DArrowLeft />
				</el-icon>
				<h3>角色用户</h3>
			</el-form-item>
			<el-form-item>
				<el-input v-model="infoData.searchInput" placeholder="请输入名称" clearable @clear='getTableData'>
					<template #append>
						<el-button icon="Search" @click="getTableData" />
					</template>
				</el-input>
			</el-form-item>
		</el-form>
		<el-table :data="infoData.tableData" stripe border v-loading='infoData.loading' height='86%'
			table-layout="fixed">
			<el-table-column type="index" width="50" />
			<el-table-column prop="userNameShow" label="用户名称" />
			<el-table-column prop="roleNameShow" label="角色类型" />
		</el-table>
		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="infoData.pageInfo.pageIndex" :page-sizes="[20, 50, 100,200,500,1000]"
			:page-size="infoData.pageInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
			:total="infoData.pageInfo.totalRowCount" v-if='infoData.pageInfo.totalRowCount' class='pageinfo'>
		</el-pagination>
	</div>
</template>

<script>
	import {
		onMounted,
		reactive
	} from "vue-demi";
	import api from "../../http/apis";
	import {
		ElMessageBox,
		ElMessage
	} from "element-plus";
	import {
		useStore
	} from "vuex";
	import {
		useRouter,
		useRoute
	} from 'vue-router';
	import {
		DArrowLeft
	} from '@element-plus/icons-vue'
	export default {
		setup() {
			const store = useStore();
			const router = useRouter();
			const roleId = router.currentRoute.value.query.roleId
			const infoData = reactive({
				tableData: [],
				loading: false,
				searchInput: '',
				pageInfo: {},
			});


			const getTableData = async () => {
				infoData.loading = true
				const {
					data
				} = await api.userApi.queryRoleUser({
					page: infoData.pageInfo.pageIndex || 1,
					rows: infoData.pageInfo.pageSize || 20,
					sort: '',
					value: infoData.searchInput,
					intId: parseInt(roleId)
				});
				if (data.isSuccessful) {
					infoData.loading = false
					infoData.tableData = data.resultObj.data
					infoData.pageInfo = data.resultObj.pagerInfo
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
				} else {
					ElMessage({});
				}
			};
			getTableData();
			return {
				infoData,
				getTableData
			};
		},
		methods: {
			handleSizeChange(val) {
				this.infoData.pageInfo.pageSize = val;
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.infoData.pageInfo.pageIndex = val;
				this.getTableData();
			},
			getBack() {
				window.history.go(-1)
			},
		}
	};
</script>

<style scoped lang='scss'>
	@use "../../assets/scss/table.scss"as *;

	.el-input__inner {
		width: 100%;
	}
</style>
